import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Home = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Home" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M10.8906 0.616494C11.6092 0.136875 12.5641 0.171206 13.249 0.719033L21.874 7.61845C22.5857 8.18775 23 9.04989 23 9.96122V21.0003C22.9998 22.1047 22.1044 23.0003 21 23.0003H16.667C15.5625 23.0003 14.6672 22.1047 14.667 21.0003V14.3255H9.33301V21.0003C9.33281 22.1047 8.43745 23.0003 7.33301 23.0003H3C1.89555 23.0003 1.0002 22.1047 1 21.0003V9.96122C1.00001 9.04989 1.41435 8.18775 2.12598 7.61845L10.751 0.719033L10.8906 0.616494ZM3.375 9.17997C3.13781 9.36973 3.00001 9.65747 3 9.96122V21.0003H7.33301V14.3255C7.33305 13.2211 8.22861 12.3257 9.33301 12.3255H14.667C15.7714 12.3257 16.6669 13.2211 16.667 14.3255V21.0003H21V9.96122C21 9.65747 20.8622 9.36973 20.625 9.17997L12 2.28056L3.375 9.17997Z" fill="#000" />
  </StyledIcon>
));

Home.displayName = 'Home';

export { Home };
